import { render, staticRenderFns } from "./BsImageHolder.vue?vue&type=template&id=7479e878&scoped=true&"
import script from "./BsImageHolder.vue?vue&type=script&lang=js&"
export * from "./BsImageHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479e878",
  null
  
)

export default component.exports